export default __webpack_public_path__ + "static/media/info-primary.970b3c15.svg";